import { render, staticRenderFns } from "./positionBanner.vue?vue&type=template&id=33e5b7ac&scoped=true"
import script from "./positionBanner.vue?vue&type=script&lang=js"
export * from "./positionBanner.vue?vue&type=script&lang=js"
import style0 from "./positionBanner.vue?vue&type=style&index=0&id=33e5b7ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5b7ac",
  null
  
)

export default component.exports